import React from 'react';
import * as Clipboard from 'expo-clipboard';

const copyToClipboard = async content => {
  await Clipboard.setStringAsync(content);
};

export default copyToClipboard;
